import { render, staticRenderFns } from "./BlockReviewEstimate.vue?vue&type=template&id=051160fc&scoped=true&"
import script from "./BlockReviewEstimate.vue?vue&type=script&lang=ts&"
export * from "./BlockReviewEstimate.vue?vue&type=script&lang=ts&"
import style0 from "./BlockReviewEstimate.vue?vue&type=style&index=0&id=051160fc&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "051160fc",
  null
  
)

export default component.exports